import React, { useState, useEffect, Fragment } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Button,
  Row,
  Col,
  Progress,
  Form,
  FormGroup,
} from "reactstrap";
import { H2, H4, H6, P } from "../../AbstractElements";
import PartOne from "./PartOne";
import DataDiri from "./DataDiri";
import TransportasiBerangkat from "./TransportasiBerangkat";
import TransportasiPulang from "./TransportasiPulang";
import DressCode from "./DressCode";
import RiwayatPenyakit from "./RiwayatPenyakit";
import PreviewJawaban from "./PreviewJawaban"; // Import komponen baru
import { useForm } from "react-hook-form";
import { useParams, useSearchParams } from "react-router-dom";
import { API_URL } from "../../Constant";
import itinerary from "../../assets/images/Fasilkom Itenary Cabil 2025.png";
import ImageWithLightbox from "./ImageWithLightbox";

const Cabil3Contain = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const myParam = searchParams.get("22254258");

  const {
    control,
    handleSubmit,
    formState: { errors, isValid },
    watch,
    reset,
    setValue,
  } = useForm({
    mode: "onChange",
    defaultValues: {
      nama: "",
      nama_ktp: "",
      nik: "",
      maskapai_berangkat: "",
      transportasi_berangkat: "",
      maskapai_pulang: "",
      transportasi_pulang: "",
      ukuran_pakaian: "",
      ukuran_pakaian_lainnya: "",
      lengan_pakaian: "",
      alergi_makanan: [],
      alergi_makanan_lainnya: "",
      alergi_seafood: "",
      penyakit: "",
      penyakit_detail: "",
      makan_pedas: "",
      wisata: "",
    },
  });
  const [part, setPart] = useState(1);
  const [pending, setPending] = useState(false);

  useEffect(() => {
    if (!myParam) return;
    setPending(true);
    fetch(`${API_URL}cabil/by-uuid3/${myParam}/`)
      .then((res) => {
        if (!res.ok) throw new Error("Gagal mengambil data");
        return res.json();
      })
      .then((data) => {
        console.log(data);
        reset(data);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => setPending(false));
  }, [myParam, reset]);

  const handleNext = () => {
    setPart(part + 1);
    window.scrollTo(0, 0);
  };

  const handleBack = () => {
    setPart(part - 1);
    window.scrollTo(0, 0);
  };

  const getCurrentComponent = () => {
    switch (part) {
      case 1:
        return <PartOne control={control} watch={watch} />;
      case 2:
        return <DataDiri control={control} watch={watch} />;
      case 3:
        return <TransportasiBerangkat control={control} watch={watch} />;
      case 4:
        return <TransportasiPulang control={control} watch={watch} />;
      case 5:
        return (
          <DressCode control={control} watch={watch} setValue={setValue} />
        );
      case 6:
        return (
          <RiwayatPenyakit
            control={control}
            watch={watch}
            setValue={setValue}
          />
        );
      case 7:
        return (
          <PreviewJawaban watch={watch} control={control} setValue={setValue} />
        ); // Tambahkan komponen baru untuk preview jawaban
      default:
        return <PartOne control={control} />;
    }
  };

  const postForm = async (data) => {
    setPending(true);
    try {
      const response = await fetch(`${API_URL}cabil/update3/`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const errorData = await response.json();
        alert(errorData.error || "Gagal menyimpan data");
        window.location.reload();
        return;
      }

      const result = await response.json();
      alert("✅ Data berhasil disimpan!");
      window.location.reload();
    } catch (err) {
      alert("Terjadi kesalahan saat menyimpan data");
      console.error(err);
    } finally {
      setPending(false);
    }
  };

  return (
    <Fragment>
      <div className="container-fluid">
        <Row className="justify-content-center mt-5">
          <Col sm="12" md="10" lg="8">
            <Card className="border-0 shadow-sm">
              <CardHeader className="bg-primary text-white">
                <H2 className="text-white">Capacity Building FASILKOM UI:</H2>
                <H2 className="text-white">
                  Labuan Bajo, Kamis – Minggu, 26 - 29 Juni 2025
                </H2>
              </CardHeader>

              <CardBody className="px-4 py-4">
                {watch("submit") && (
                  <>
                    <div className="mb-5">
                      <H6>Terima kasih telah mengisi form ini. See You at Labuan Bajo.</H6>
                    </div>
                    <div className="text-center mb-4">
                      <ImageWithLightbox 
                        src={itinerary} 
                        alt="Itinerary"
                        style={{
                          margin: "auto", 
                          width: "100%", 
                          maxWidth: "600px", 
                          height: "auto", 
                          display: "block"
                        }} 
                      />
                    </div>
                    <FormGroup style={{border: "1px solid #ccc", padding: "20px", borderRadius: "5px", marginBottom: "20px"}}>
                      <label className="bg-transparent">
                        Preview aktivitas hari ke-3 yang telah Anda pilih sebelumnya.
                      </label>
                      <P>{watch("wisata")}</P>
                    </FormGroup>
                    <DataDiri control={control} watch={watch} preview={true} />
                    <br />
                    <TransportasiBerangkat control={control} watch={watch} preview={true} />
                    <br />
                    <TransportasiPulang control={control} watch={watch} preview={true} />
                    <br />
                    <DressCode control={control} watch={watch} setValue={setValue} preview={true} />
                    <br />
                    <RiwayatPenyakit control={control} watch={watch} setValue={setValue} preview={true} />
                  </>
                )}
                {!watch("submit") && (
                  <Form onSubmit={handleSubmit(postForm)}>
                    <div className="form-section">{getCurrentComponent()}</div>

                    <div className="form-navigation mt-4">
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <div>
                          {part > 1 && (
                            <Button
                              color="primary"
                              type="button"
                              onClick={handleBack}
                            >
                              Kembali
                            </Button>
                          )}
                        </div>
                        <div className="ml-auto">
                          {part < 7 && (
                            <Button
                              color="primary"
                              type="button"
                              onClick={handleNext}
                            >
                              Berikutnya
                            </Button>
                          )}
                          {part === 7 && (
                            <Button
                              color="success"
                              type="submit"
                              disabled={!isValid || pending || watch("submit")}
                            >
                              Kirim
                            </Button>
                          )}
                        </div>
                      </div>

                      <div className="d-flex justify-content-between align-items-center">
                        <Progress
                          value={(part / 7) * 100} // Ubah dari 6 ke 7 untuk menyertakan preview
                          className="w-100 rounded-pill"
                          style={{ height: "10px" }}
                        />
                        <span className="ml-3 text-secondary">{part}/7</span>{" "}
                        {/* Ubah dari 6 ke 7 */}
                      </div>
                    </div>
                  </Form>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>

      <style jsx>{`
        .purple-header {
          border-radius: 8px;
        }
        .form-section {
          animation: fadeIn 0.3s ease-in-out;
        }
        .text-purple {
          color: #673ab7;
        }
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        input[type="radio"],
        input[type="checkbox"] {
          position: relative;
          appearance: none;
          -webkit-appearance: none;
          -moz-appearance: none;
          width: 18px;
          height: 18px;
          border: 1px solid #ced4da;
          outline: none;
          cursor: pointer;
        }

        input[type="radio"] {
          border-radius: 50%;
        }

        input[type="checkbox"] {
          border-radius: 3px;
        }

        input[type="radio"]:checked,
        input[type="checkbox"]:checked {
          background-color: black;
          border-color: black;
        }

        input[type="checkbox"]:checked::after {
          content: "";
          position: absolute;
          left: 6px;
          top: 2px;
          width: 5px;
          height: 10px;
          border: solid white;
          border-width: 0 2px 2px 0;
          transform: rotate(45deg);
        }

        input[type="radio"]:disabled,
        input[type="checkbox"]:disabled {
          background-color: #e9ecef;
          opacity: 0.65;
          cursor: not-allowed;
        }
      `}</style>
    </Fragment>
  );
};

export default Cabil3Contain;
